import { render, staticRenderFns } from "./IconBank.vue?vue&type=template&id=6cdcdfb0&scoped=true&"
import script from "./IconBank.vue?vue&type=script&lang=js&"
export * from "./IconBank.vue?vue&type=script&lang=js&"
import style0 from "./IconBank.vue?vue&type=style&index=0&id=6cdcdfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcdfb0",
  null
  
)

export default component.exports